import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import ErrorToast from "../ErrorToast";
import WarningToast from "../WarningToast";
import SuccessToast from "../SuccessToast";
import axios from "../../API/axios";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import { useTranslation } from "react-i18next";
import { set } from "lodash";
import ModalForGuest from "../ModalForGuest";

const ProfileNegativeActions = ({
  CheckConnectUser,
  connectionId,
  userData,
  uid,
  CompUid,
  getUserProfile,
  connectionCheck,
  type,
  companyDetails,
  CompanyDetailsApiCall,
  setCompanyDetails,
  updateForrlow,
  isfollowed,
  setIsfollowed,
  setCheckblock,
  checkblock,
  setDisconectCheck,
  disconectCheck
  
}) => {
  console.log("userDataoooooooooo", userData?.profileInfo?.isOwn);  
  const sessionId = localStorage.getItem("sessionId");
  const guestModeData = localStorage.getItem("guestMode");
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const language = localStorage.getItem("Lang");
  const { t } = useTranslation();
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //************************Block Company  ************************//

   const [showBlockCompany, setshowBlockCompany] = useState(false);

  const handleCloseBlockComp = () => setshowBlockCompany(false);
  const handleShowBlockComp = () => setshowBlockCompany(true);

  
  const [compUid, setCompUid] = useState(null)
  const [checkblockC, setcheckblockC] = useState(companyDetails?.isBlockedByYou)
  const BlockCompany = async () => {
   const data = {  
    deviceType : "Web",
      sessionId: sessionId,
      compUid : compUid,
      langKey: language === "en" ? "" : language,
   }
    try {
      const res = await axios.post("/Company/BlockCompany", data, {
         
      });
      setToastMessage(res.data.message);
      setShowToast(true);
      setcheckblockC(true) ;
      setCompanyDetails({...companyDetails, isBlockedByYou: true})
      handleCloseBlockComp();
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Block Company  ************************//
  //************************un-Block Company  ************************//
  const unBlockCompany = async (id) => {
    // return;
     const data = {  
    deviceType : "Web",
      sessionId: sessionId,
      compUid : id,
      langKey: language === "en" ? "" : language,
   }
   try {
      const res = await axios.post("/Company/UnblockCompany", data, {
      });
      setToastMessage(res.data.message);
      setShowToast(true);
      setcheckblockC(false)
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************unn-Block Company  ************************//
  //************************Block User  ************************//

  const [checkConnect, setCheckConnect] = useState(userData && userData?.profileInfo?.isConnectedByYou)
  const [showBlockModal, setshowBlockModal] = useState(false);

  const handleCloseBlockModal = () => setshowBlockModal(false);
  const handleShowBlock = () => setshowBlockModal(true);


  const BlockUser = async () => { 
    const responseData = {
      DeviceType : "Web",
      sessionId: sessionId,
      UserUid : uid,
      LangKey: language === "en" ? "" : language,
    };
    try {
      const res = await axios.post("User/BlockUser", responseData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setToastMessage(res.data.message);
      setShowToast(true);
      setCheckblock(true)
       handleCloseBlockModal(); 
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************Block User  ************************//

  //************************UnBlock User  ************************//

  const unblockUser = async () => { 
    const responseData = {
      DeviceType : "Web",
      sessionId: sessionId,
      UserUid : uid,
      LangKey: language === "en" ? "" : language,
    };
    
    try {
      const res = await axios.post("User/UnBlockUser", responseData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setToastMessage(res.data.message);
      setShowToast(true);
      setCheckblock(false)

      // getUserProfile();
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************UnBlock User  ************************//
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  //************************Unfollow User  ************************//
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const unFollowUser = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`UserFollow/UnfollowUser`, responseData).then((res) => {
        // toast.success("User Unfollowed");
        setToastMessage(res.data.message);
        setShowToast(true);
        setShowModal(false);
        setIsfollowed(false);
        getUserProfile();
        // updateForrlow()
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Unfollow User  ************************//

  //************************Disconnect Request   ************************//
  const [disconectshow, setDisconectShow] = useState(false);
  const DisconnectClose = () => {
    setDisconectShow(false);
  };
  const Disconnect = async (id) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      langKey: language === "en" ? "" : language,
    };
    // console.log(data);
    try {
      await axios.post("Connection/DisconnectUser", data).then((resData) => {
        console.log(resData);
        setDisconectShow(false);  // Close disconnect modal
        setShowDropdown(false);   // Close dropdown menu
        //   toast.success(resData.data.message);
        setToastMessage(resData.data.message);
        setShowToast(true);
        setDisconectCheck(false);  // Update state immediately - this shows connect button
        CheckConnectUser();  // Refresh connection status from server
      });
    } catch (e) {
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************Disconnect Request ************************//
  const [show, setShow] = useState(false);
  const cancelRequestClose = () => {
    setShow(false);
  };
  const RejectRequest = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      userUID: uid,
      connectID: connectionId,
      actionType: "Reject",
      langKey: language === "en" ? "" : language,
    };
    console.log(data);
    try {
      await axios
        .post("Connection/ConnectionRequestAction", data)
        .then((resData) => {
          console.log(resData.data.message);
          //   toast.success(resData.data.message);
          setToastMessage(resData.data.message);
          setShowToast(true);
          CheckConnectUser();
        });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open"); // When a modal opens
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open"); // When a modal closes
    }
  }, [showModal]);

  const [jobModal, setJobModal] = useState(false);
  const closeModalData = () => {
    setJobModal(false);
  };

  
  return (
    <>
      <div
        className="postMenu pointer ms-auto"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <MoreHorizSharpIcon className="material-symbols-sharp mt-2" />
        {showDropdown && type === "user" && (
          <Dropdown.Menu
            show={showDropdown}
            ref={dropdownRef}
            className="InteractionModal"
          >
            {/* {userData && userData?.profileInfo?.isBlockedByYou ? ( */}
            {checkblock ? (
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={() => {
                    unblockUser();
                  }}
                >
                  <div className="d-flex align-items-center">
                    <span className="dropdownTxt f-14">{t("Recommendations.Unblock")}</span>
                  </div>
                  {/* <p className="f-12 dropdownPara">Unblock User</p> */}
                </div>
              </Dropdown.Item>
            ) : (
              <Dropdown.Item as="button" className="dropdownList ">
                <div
                  onClick={() => {
                    if (guestModeData === "true") {
                      setJobModal(true);
                    } else {
                      handleShowBlock();
                    }
                  }}
                >
                  <div className="d-flex align-items-center">
                    <span className="dropdownTxt f-14">{t("Recommendations.Block")}</span>
                  </div>
                  {/* <p className="f-12 dropdownPara">Block User</p> */}
                </div>
              </Dropdown.Item>
            )}

            {isfollowed && (
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={() => {
                    handleShow();
                  }}
                  // onClick={BlockUser}
                >
                  <div className="d-flex align-items-center">
                    <span className="dropdownTxt f-14"> {t("Recommendations.Unfollow")}</span>
                  </div>
                  {/* <p className="f-12 dropdownPara">Unfollow User</p> */}
                </div>
              </Dropdown.Item>
            )}
            {/* {connectionCheck === "Connected" && ( */}
            {(userData?.profileInfo?.isConnectedByYou === true || disconectCheck === true) && (
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={() => {
                    setDisconectShow(!disconectshow);
                  }}
                  // onClick={BlockUser}
                >
                  <div className="d-flex align-items-center">
                    <span className="dropdownTxt f-14">{t("Connections.Disconnect")}</span>
                  </div>
                  {/* <p className="f-12 dropdownPara">Disconnect User</p> */}
                </div>
              </Dropdown.Item>
            )}
            
          </Dropdown.Menu>
        )}
        
        {showDropdown && type === "company" && (
          <Dropdown.Menu
            show={showDropdown}
            ref={dropdownRef}
            className="InteractionModal"
          >
            
            {checkblockC === true ? (
              <Dropdown.Item as="button" className="dropdownList">
                <div
                  onClick={() => {
                    unBlockCompany(companyDetails.compUid);
                  }}
                >
                  <div className="d-flex align-items-center">
                    <span className="dropdownTxt f-14">{t("Recommendations.Unblock")}</span>
                  </div>
                  {/* <p className="f-12 dropdownPara">Unblock Company</p> */}
                </div>
              </Dropdown.Item>
            ) : (
              <Dropdown.Item as="button" className="dropdownList ">
                <div
                  onClick={() => {
                    if (guestModeData === "true") {
                      setJobModal(true);
                    } else {
                      handleShowBlockComp();
                      setCompUid(companyDetails.compUid);
                    }
                  }} 
                >
                  <div className="d-flex align-items-center">
                    <span className="dropdownTxt f-14">{t("Recommendations.Block")}</span>
                  </div>
                  {/* <p className="f-12 dropdownPara">Block Company</p> */}
                </div>
              </Dropdown.Item>
            )}
          </Dropdown.Menu>
        )}
      </div>

      {jobModal && <ModalForGuest closeModalData={closeModalData} />}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {showModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>  {t("modals.Are you sure you want to unfollow")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseModal();
                  }}
                />
              </div>

              <div>
                <div className="col-md-12 mt-4 d-flex justify-content-center">
                  <button
                    type="button"
                    className="closebtn"
                    onClick={() => unFollowUser()}
                  >
                 {t("Recommendations.Unfollow")}  
                  </button>
                </div>
              </div>
 
            </div>
          </div>
        </div>
      )}

      {disconectshow && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("modals.Are you sure you want to Disconnect")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    DisconnectClose();
                  }}
                />
              </div>

              <div className="text-center mt-2">
                <button
                  color=""
                  className="closebtn"
                  onClick={() => Disconnect()}
                >
                  {t("modals.Yes")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showBlockModal && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>  {t("modals.Are you sure you want to block")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseBlockModal();
                  }}
                />
              </div>

              <div>
                <div className="col-md-12 mt-4 d-flex justify-content-center">
                  <button
                    type="button"
                    className="closebtn"
                    onClick={() => BlockUser()}
                  >
                                      {t("Recommendations.Block")}  
                  </button>
                </div>
              </div>
 
            </div>
          </div>
        </div>
      )}

      {showBlockCompany && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around p-2">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>  {t("modals.Are you sure you want to block")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleCloseBlockComp();
                  }}
                />
              </div>

              <div>
                <div className="col-md-12 mt-4 d-flex justify-content-center">
                  <button
                    type="button"
                    className="closebtn"
                    onClick={() => BlockCompany()}
                  >
                                      {t("Recommendations.Block")}  
                  </button>
                </div>
              </div>
 
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default ProfileNegativeActions;
